const HEX = {
  NEUTRAL_900: '#1A1A1A',
  NEUTRAL_800: '#262626',
  NEUTRAL_700: '#4F4F4F',
  NEUTRAL_600: '#575A5D',
  NEUTRAL_500: '#767676',
  NEUTRAL_400: '#999999',
  NEUTRAL_300: '#C6C6C6',
  NEUTRAL_250: '#D6D6D6',
  NEUTRAL_200: '#E6E6E6',
  NEUTRAL_100: '#F5F5F5',
  NEUTRAL_50: '#FAFAFA',
  NEUTRAL_0: '#FFFFFF',

  BRAND_GREEN: '#006437',
  BLUE_500: '#1172EB',
  BLUE_600: '#0E5EC5',
  BLUE_LOGO: '#2563EB',
  BLUE_50: '#E7F1FD',

  RED_500: '#D32F2F',
  RED_50: '#FFF3F3',
  YELLOW_50: '#FFF5E2',
  YELLOW_700: '#986A14',
};

export const COLOR_TEXT_PRIMARY = HEX.NEUTRAL_900;
export const COLOR_TEXT_SECONDARY = HEX.NEUTRAL_700;
export const COLOR_TEXT_TERTIARY = HEX.NEUTRAL_500;
export const COLOR_TEXT_QUATERNARY = HEX.NEUTRAL_400;
export const COLOR_TEXT_DISABLED = HEX.NEUTRAL_250;
export const COLOR_TEXT_INVERSE = HEX.NEUTRAL_0;

export const COLOR_BACKGROUND_PRIMARY = HEX.NEUTRAL_0;
export const COLOR_BACKGROUND_LIGHT = HEX.NEUTRAL_100;
export const COLOR_BACKGROUND_RAISED = HEX.NEUTRAL_50;
export const COLOR_BACKGROUND_DARK = HEX.NEUTRAL_800;
export const COLOR_BACKGROUND_ANONYMOUS = HEX.NEUTRAL_600;

export const COLOR_BORDER_DEFAULT = HEX.NEUTRAL_200;
export const COLOR_BORDER_STRONG = HEX.NEUTRAL_300;
export const COLOR_BORDER_SUBTLE = 'rgba(255, 255, 255, 0.16)';

export const COLOR_ACCENT = HEX.BLUE_500;
export const COLOR_ACCENT_DARK = HEX.BLUE_600;
export const COLOR_ACCENT_SOFT = HEX.BLUE_50;
export const COLOR_ACCENT_LOGO = HEX.BLUE_LOGO;
export const COLOR_BRAND_DEFAULT = HEX.BRAND_GREEN;

export const COLOR_FOCUS = COLOR_TEXT_PRIMARY;

export const COLOR_ERROR = HEX.RED_500;
export const COLOR_ERROR_SOFT = HEX.RED_50;
export const COLOR_ERROR_BANNER_BG = 'rgba(211, 47, 47, 0.08)';
export const COLOR_WARNING = HEX.YELLOW_700;
export const COLOR_WARNING_SOFT = HEX.YELLOW_50;

export const COLOR_OVERLAY_HOVER = 'rgba(0, 0, 0, 0.05)';
export const COLOR_OVERLAY_LIGHT = 'rgba(0, 0, 0, 0.10)';
export const COLOR_OVERLAY_SHADOW = 'rgba(0, 0, 0, 0.12)';
export const COLOR_OVERLAY_SHADOW_STRONG = 'rgba(0, 0, 0, 0.15)';
export const COLOR_OVERLAY_BACKDROP_LIGHT = 'rgba(0, 0, 0, 0.3)';
export const COLOR_OVERLAY_BACKDROP_STRONG = 'rgba(0, 0, 0, 0.5)';

export const COLOR_PRIMARY = COLOR_TEXT_PRIMARY;
export const COLOR_SECONDARY = COLOR_TEXT_SECONDARY;
export const COLOR_BORDER = COLOR_BORDER_DEFAULT;
export const COLOR_BACKGROUND = COLOR_BACKGROUND_PRIMARY;

export const YOU_COLORS = {
  PRIMARY: COLOR_TEXT_PRIMARY,
  SECONDARY: COLOR_TEXT_SECONDARY,
  BORDER: COLOR_BORDER_DEFAULT,
  BACKGROUND: COLOR_BACKGROUND_PRIMARY,
  BACKGROUND_LIGHT: COLOR_BACKGROUND_LIGHT,
  ERROR: COLOR_ERROR,
  ACCENT: COLOR_ACCENT,
};

export const COLORS = {
  TEXT: {
    PRIMARY: COLOR_TEXT_PRIMARY,
    SECONDARY: COLOR_TEXT_SECONDARY,
    TERTIARY: COLOR_TEXT_TERTIARY,
    QUATERNARY: COLOR_TEXT_QUATERNARY,
    DISABLED: COLOR_TEXT_DISABLED,
    INVERSE: COLOR_TEXT_INVERSE,
  },
  BACKGROUND: {
    PRIMARY: COLOR_BACKGROUND_PRIMARY,
    LIGHT: COLOR_BACKGROUND_LIGHT,
    RAISED: COLOR_BACKGROUND_RAISED,
    DARK: COLOR_BACKGROUND_DARK,
    ANONYMOUS: COLOR_BACKGROUND_ANONYMOUS,
  },
  BORDER: {
    DEFAULT: COLOR_BORDER_DEFAULT,
    STRONG: COLOR_BORDER_STRONG,
    SUBTLE: COLOR_BORDER_SUBTLE,
  },
  ACCENT: {
    DEFAULT: COLOR_ACCENT,
    DARK: COLOR_ACCENT_DARK,
    SOFT: COLOR_ACCENT_SOFT,
    LOGO: COLOR_ACCENT_LOGO,
  },
  BRAND: {
    DEFAULT: COLOR_BRAND_DEFAULT,
  },
  FOCUS: {
    DEFAULT: COLOR_FOCUS,
  },
  ERROR: {
    DEFAULT: COLOR_ERROR,
    SOFT: COLOR_ERROR_SOFT,
    BANNER_BG: COLOR_ERROR_BANNER_BG,
  },
  WARNING: {
    DEFAULT: COLOR_WARNING,
    SOFT: COLOR_WARNING_SOFT,
  },
  OVERLAY: {
    HOVER: COLOR_OVERLAY_HOVER,
    LIGHT: COLOR_OVERLAY_LIGHT,
    SHADOW: COLOR_OVERLAY_SHADOW,
    SHADOW_STRONG: COLOR_OVERLAY_SHADOW_STRONG,
    BACKDROP_LIGHT: COLOR_OVERLAY_BACKDROP_LIGHT,
    BACKDROP_STRONG: COLOR_OVERLAY_BACKDROP_STRONG,
  },
};
